<template>
  <div class="medical-consultation">
    <div class="left">
      <mk-left @selectItem="selectItem" />
    </div>
    <div class="center">
      <mk-center v-if="activeItem" :info="activeItem" />
      <empty v-else />
    </div>
    <div class="right">
      <medicalRecordList
        v-if="activeItem"
        :info="activeItem"
        :patientCode="activeItem.patientCode"
        :viewType="1"
      />
      <empty v-else />
    </div>
  </div>
</template>

<script>
import mkLeft from "./com/mk-left.vue";
import mkCenter from "./com/mk-center.vue";
import medicalRecordList from "@/com/medicalRecordList.vue";
export default {
  components: {
    mkLeft,
    mkCenter,
    medicalRecordList,
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      activeItem: "",
    };
  },
  methods: {
    selectItem(item) {
      this.activeItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-consultation {
  padding: 15px;
  display: flex;
  height: 100%;
  background: #f5f5f5;
  & > div {
    height: 100%;
    background: #fff;
    border-radius: 5px;
  }
  .left {
    width: 350px;
    margin-right: 15px;
  }
  .center {
    flex: 1;
    margin-right: 15px;
  }
  .right {
    width: 500px;
    flex-shrink: 0;
  }
}
</style>